import React, { useEffect, useState } from "react";
import HttpApis from "../../services/HttpApis";
import { useNavigate } from "react-router-dom";
import Standard from "../Standard/standard";
import Banner from "../Banner/bannner";
import NoDataFound from "../noData/NoDataFound";
import SpinLoader from "../loader/SpinLoader";

const MyListPage = () => {
  const [movies, setMovies] = useState([]);
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate();

  const handleDetails = (slug, type) => {
    navigate(`/details/${type}/${slug}`);
  };

  const fetchMyList = async () => {
    try {
       setLoading(true)
      const response = await HttpApis.getList();
      const sections = response?.data?.data || [];
      const allItems = sections.flatMap((sec) => sec.content || []);
      setMovies(allItems);
    } catch (error) {
      console.error("Error fetching My List movies:", error);
    }finally{
      setLoading(false)
    }
  };

  useEffect(() => {
    fetchMyList();
  }, []);

  if(loading){
    return <SpinLoader/>
  }
  if (movies.length === 0) return <NoDataFound message="Your list is empty.."/>;

  const sectionDataForBanner = [
    {
      type: "carousel",
      items: movies,
    },
  ];
  if (movies.length === 1) {
    return (
      <div>
        <Banner sectionData={sectionDataForBanner} handleDetails={handleDetails} />
      </div>
    );
  }

  const otherMovies = movies.slice(1);

  const sectionData = [
    {
      type: "gallery",
      title: "My List",
      items: otherMovies,
    },
  ];

  return (
    <div>
      <Banner sectionData={sectionDataForBanner} handleDetails={handleDetails} />
      <Standard
        sectionData={sectionData}
        handleDetails={handleDetails} // Standard now passes type automatically
      />
    </div>
  );
};

export default MyListPage;